import React, { Component } from 'react'
import { Route }            from 'react-router-dom'

import Meta         from './components/meta'
import Attachments  from './components/attachments'
import Content      from './components/content'
import Modal        from './components/modal'

import './css/document.css'

export default class Item extends Component {

  state = {}

  componentDidMount() {
    this.load(this.props)
  }

  componentWillReceiveProps(props) {
    this.load(props)
  }
  
  load(props) {
    this.setState({item: props.item})
  }

  render() {
    return !this.state.item ? '' : (
      <div className="document">
        <Meta data={this.props.data} item={this.state.item} />
        <h1 className="document-title">{this.state.item.title}</h1>
        {(this.state.item.author || this.state.item.location || this.state.item.date) && (
          <Subtitle author={this.state.item.author || this.state.item.location} date={this.state.item.date} />
        )}
        {this.state.item.content && (
          <Content text={this.state.item.content} brightnessHint={this.state.item.white && this.props.data.content.brightness_hint} />
        )}
        {this.state.item.attachments && (
          <div>
            <div className="document-attachments">
              <Attachments attachments={this.state.item.attachments} />
            </div>
            <Route exact={true} path={this.state.item.section.attachment_url} render={({ match }) => {
              let attachment = this.state.item.getAttachment(match.params.attachment)
              if (!attachment) {
                return ''
              }
              return <Modal data={this.props.data} attachment={attachment} />
            }} />
          </div>
        )}
      </div>
    )
  }

}

function Subtitle(props) {
  return (
    <div className="document-subtitle">
      <h2 className="document-author">{props.author || ''}</h2>
      <h2 className="document-date">{props.date || ''}</h2>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/document.js